import { Appearance, Background, BackgroundType, Design, DesignType } from '../designConstants';

export const getButtonDesign = (
  background: BackgroundType,
  active: boolean,
  design: DesignType = Design.BRAND
) => {
  /* 
  Button is filled if:
    - active
    - inactive BUT light+brand
  Otherwise button is outlined
  */
  const appearance =
    active || (background === Background.LIGHT && design === Design.BRAND)
      ? Appearance.FILLED
      : Appearance.OUTLINED;

  /*
  Button is brand colors if:
    - brand+light+active
    - brand+dark
    - neutral+dark+inactive
  Otherwise button is neutral
  */
  const buttonDesign =
    (design === Design.BRAND && !(background === Background.LIGHT && !active)) ||
    (design === Design.NEUTRAL && background === Background.DARK && !active)
      ? Design.BRAND
      : Design.NEUTRAL;

  return { design: buttonDesign, appearance };
};

export const getIsActive =
  <T extends string>(
    modeProps:
      | { isExclusiveSelect: false; selectedOptions: T[] }
      | { isExclusiveSelect?: true; selectedOption: T }
  ) =>
  (key: T): boolean =>
    modeProps.isExclusiveSelect === false
      ? modeProps.selectedOptions.includes(key)
      : modeProps.selectedOption === key;
